export function formatNumberWithCommas(number) {
    return new Intl.NumberFormat('en-EN', {}).format(number);
}
